
import { BrowserRouter, Routes, Route} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import './App.css';
import Home from "./components/home/Home";
import Creator from "./components/creator/Creator";
import Existing from "./components/existing/Existing";
import Response from "./components/surveyResponse/Response";
import Analyse from "./components/analyse/Analyse";
import NavbarComp from "./navbar/NavbarComp";
import Editor from "./components/editor/Editor";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
          {/* <NavbarComp /> */}
          <div style={{height:"100%"}}>
        
          <Routes>
            <Route exact path="/" element={<div><NavbarComp/><Home /></div>} />
            <Route exact path="/create" element={<div><NavbarComp/><Creator /></div>} />
            <Route exact path="/existing" element={<div><NavbarComp/><Existing /></div>} />
            
            <Route exact path="/edit/:gid" element={<div><NavbarComp/><Editor /></div>} />
            <Route exact path="/response/:gid" element={<Response />} />
            <Route exact path="/analyse/:gid" element={<div><NavbarComp/><Analyse /></div>} />

            {/* <Route exact path="/problems" element={<Problems />} /> */}

        
            {/* <Route exact path="/user/:email" style={{
                "height":"{window.innerHeight} !important",
              }}
              element={<Portfolio />}
            /> */}

        </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
